import { render, staticRenderFns } from "./addRoleStaff.vue?vue&type=template&id=571204d9&scoped=true"
import script from "./addRoleStaff.vue?vue&type=script&lang=js"
export * from "./addRoleStaff.vue?vue&type=script&lang=js"
import style0 from "./addRoleStaff.vue?vue&type=style&index=0&id=571204d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571204d9",
  null
  
)

export default component.exports